var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.882458 0H12.1173C12.8503 0 13.2628 0.833977 12.813 1.40669L8.1556 7.33772C8.03548 7.49069 7.97027 7.67889 7.97027 7.87261V18.5633C7.97027 18.994 7.40609 19.1638 7.16375 18.806L4.53997 14.9318C4.44274 14.7882 4.39083 14.6193 4.39083 14.4465V8.57848C4.39083 8.42019 4.34727 8.26488 4.26483 8.12922L0.127361 1.32105C-0.22576 0.739991 0.19721 0 0.882458 0Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.41b90abd21a5c184d8e7ea3ee2df60e1.svg";
export { ForwardRef as ReactComponent };